import { apiClient } from '../../../gateways/api'
import type { Klantgegevens } from '../types/Klantgegevens'

export { fetchKlantgegevens }

const fetchKlantgegevens = async ({
  id,
}: {
  id: string
}): Promise<Klantgegevens> => {
  const { data } = await apiClient({
    url: `/rest/project/${id}/klant`,
    method: 'GET',
  })

  return data
}
